<template>
  <span>
    <ProductionTriggerDialog
      v-model="isConfirmationDialogOpen"
      :trigger-production="triggerProduction"
      :show-alert="showTriggerAlert"
      :alert-message="triggerAlertMessage"
      :title="$cmsService.getContent(content, 'production_dialog_title')"
      :order-values="orderValues"
      :dialog-content="
        $cmsService.getContent(content, 'production_dialog_content')
      "
      :button="$cmsService.getContent(content, 'send')"
    >
    </ProductionTriggerDialog>
    <v-container class="mx-0  ">
      <v-card-text class="px-0">
        <PartialBatchesTable
          :get-content="getContent"
          @setItems="setItems"
          @setOrderValues="setOrderValues"
        ></PartialBatchesTable>
      </v-card-text>
      <h1 class="headline justify-center my-5 text-center primary--text ">
        {{ $cmsService.getContent(content, 'production_summary') }}
      </h1>
      <v-card>
        <v-card-text class="text-center">
          <b>{{ $cmsService.getContent(content, 'document_amount') + ':' }}</b>
          <span class="primary--text text--accent-2 pr-2">
            {{ orderValues.orderDocumentsAmount }}
          </span>
          <b>{{ $cmsService.getContent(content, 'regions_amount') + ':' }}</b>
          <span class="primary--text text--accent-2 pr-2">
            {{ orderValues.regionsAmount }}
          </span>
          <b>{{ $cmsService.getContent(content, 'sheet_amount') + ':' }}</b>
          <span class="primary--text text--accent-2 pr-4">
            {{ orderValues.orderSheetAmount }}
          </span>
          <b>{{ $cmsService.getContent(content, 'weight') + ':' }}</b>
          <span class="primary--text text--accent-2 pr-4">
            {{ orderValues.orderWeight + ' g' }}
          </span>
          <b>{{ $cmsService.getContent(content, 'batches') + ':' }}</b>
          <span class="primary--text text--accent-2 pr-4">
            {{ orderValues.orderBatches }}
          </span>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            id="submitProductionOrder"
            :disabled="!orderValues.orderDocumentsAmount"
            class="text-center px-8"
            color="primary"
            dark
            depressed
            @click.stop="openDialog"
            >{{ $cmsService.getContent(content, 'send') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-container>
  </span>
</template>
<script>
import ProductionTriggerDialog from '@/components/dialogs/ProductionTriggerDialog'
import formContentJson from '@/data/json/forms/ProductionInformation.json'
import { cmsService, planningService } from '../../services'
import PartialBatchesTable from '../tables/PartialBatchesTable'

export default {
  components: {
    PartialBatchesTable,
    ProductionTriggerDialog
  },
  data: () => ({
    content: formContentJson.data,
    isConfirmationDialogOpen: false,
    orderValues: {
      regionsAmount: 0,
      orderSheetAmount: 0,
      orderWeight: 0,
      orderFullBatches: 0,
      orderPartialBatches: 0
    },
    showTriggerAlert: false,
    triggerAlertMessage: ''
  }),
  created: function() {},
  methods: {
    getDocumentsToBeSend() {
      const returnArray = []
      this.orderValues.itemsToBeSent.forEach(item => {
        item.documents.forEach(documentId => {
          returnArray.push(documentId)
        })
      })
      return returnArray
    },
    triggerProduction() {
      planningService
        .triggerProduction(this.getDocumentsToBeSend())
        .then(() => {
          this.isConfirmationDialogOpen = false
          this.items = []
          this.showTriggerAlert = false
          this.triggerAlertMessage = ''
          this.setItems([])
          window.location.reload()
        })
        .catch(e => {
          this.isConfirmationDialogOpen = true
          this.showTriggerAlert = true
          this.triggerAlertMessage = this.getError(e.response.status)
        })
    },
    getError: function(errorKey) {
      return this.$store.getters.error({
        errorKey: errorKey,
        route: this.$route.name
      })
    },
    getContent: function(name) {
      const returnValue = cmsService.filterCMSContent(
        formContentJson.data,
        name
      )
      return returnValue
    },
    setOrderValues: function(orderValues) {
      this.orderValues = orderValues
    },
    setItems: function(items) {
      this.items = items
    },
    openDialog: function() {
      this.isConfirmationDialogOpen = true
    }
  }
}
</script>
